var _circle, _ellipse, _circle2, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 128.5,
    fill: "#EEFAF1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.5,
    cy: 129,
    rx: 108,
    ry: 108.5,
    fill: "#DDEFE2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 128.5,
    r: 87,
    fill: "#C8E9D1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 79,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 79,
    width: 100,
    height: 100,
    fill: "url(#pattern0_80_333)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 79,
    width: 100,
    height: 100,
    fill: "#139A38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_80_333",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_80_333",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_80_333",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEJklEQVR4nO2cSWsUQRSAK2IU9ep6csG7f0Hc4xKEiN5EcEFF8KZRCQjivuACngQJ4iGguBujHtxunnIJeHLF7eQCZoIZP3lMCUNIYk+nuutVd33QMJeervdRU1Nd9V4ZE4lEIpFIJBKJRCKRxgEmAi3ABeAF8BWo2Es+PwfOA8uBCSkeUW6AKcAB4BPJ+QjsAyb7bn8QAKuAd6TnLbDCdxyqAQ4Cfxg7VaDDdzwqAY7gntO+41IFsJPs2G7KAjAd2CA9DLgOPLLXFduTZRaRFf32GVfqnnsNOAWsl7aZ0AGWAXeBQfQibbsDLDGhAcwDHhMeD4E5JgSANuAH4fIdWGs0A2y1U6vQGQS2GMU9uQiS62Xr6tnA3MCHi5H4Ccw3Wgj0jy8pPUbRFK7oLNIg+h7F55aGNz7NLyOu+A1M8ylaXqvLwjqfomXtoiyc8ClaFojKQpdP0UWe1g3lgU/RPYRHBdgLzLSXfB5IcN99n6JljTc0yS3DxNGe4N5OP5ZrDTxK4JIFYFaC+48Yj9tPWe6M5CK5AdH9uW+LAScJh8pokm08kg+SlGN5pgQUSXJLil9mRx7JLdWSS8Y6yCZJR1KtgDeEwQCw5j/xLLfjblokm2pKFqIlF67sPXko7VlkdTaScFgGycIHoNml6JXoZyCH4WI4lroULfnJmqnk3JPrOetStCSBu+KZTPyBXcDLwCULT12K/uKoUVeBprrvHQ9cCliy8NGlaFcNnTPMd49LKVuDZOGXNtHVkepMUsjWItm56M9Zb9uTXLYmyc6HDql+csErYOoYZGuTLDxxKfqcw4b1ppStUbJwxqVomei7pE+2kUZ5XhNwUcHLSL5ZTPInZuv48NCzK0p7svBepqjORKdYHHcpe4FSycIep5JtQJOA1xk0tm+0YUTpcPGvcNT9MqkNbEVGC/+9o/VshT256nQxaYQAOzJqfG9S2Z4lC/szlVwX6KGMAuj73zDiebgQjuciuS7gjfL6mads/EqWX9DuXCXnkEDTC8wY8qzVnocLPwk0OaSEfbH/B5uAywp2372mhIWY5JgWr0mOMW03D+wpAWWhy6doOYqhLBz3KbpMxUJtvsvfpDSs6PxudIkgC9ly8EnRueFVshW9hOKz0GjAntxSVLqNFiRfw57cUjS+AbONJuQQkYLVhQ8CrUYjcjxOQWQPApuNZmzP/h74cNFqQsCO2SEuOHWrG5OTIDkPwG3lLzXStptqpnBjAZgm513IUQyyOGOPrZQpYSdwOONdk377jM66IzO7bFvavL/x5QmwI0PR23zHpwpqvc41J33HpRJqW1cutqyquaUEhAq1JJ2xFI6+zjy5pShQq9Jtt3V8jSQc7pHUNd/tDw6gWXqnlJhJ9ZMtKv1lL/n8RPKTgcXOszojkUgkEolEIpFIxJSEv8LlCSp+EARrAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotSuccess);
export default __webpack_public_path__ + "static/media/ForgotSuccess.a13bdbc77e030f19eb394cdfbf7830ba.svg";
export { ForwardRef as ReactComponent };